<template>
  <div
      ref="overlay"
      class="animated-title"
      :class="animatedTitleStore.classes"
      :style="`left: ${animatedTitleStore.dimensions.left}px; top: ${animatedTitleStore.dimensions.top}px; width: ${animatedTitleStore.dimensions.width}px; height: ${animatedTitleStore.dimensions.height}px;`"
      :data-domain="animatedTitleStore.domain"
  >
    {{ animatedTitleStore.title }}
  </div>
</template>

<script lang="ts" setup>
import {useAnimatedTitleStore} from '~/store/animated-title'
import {ref} from "vue";

const animatedTitleStore = useAnimatedTitleStore()
const overlay = ref()

</script>

<style lang="postcss">
.animated-title {
  z-index: 30;
  display: none;
  position: fixed;
  transform-origin: center;

  &[data-domain="violet"] {
    color: var(--color-violet);
  }

  &[data-domain="yellow"] {
    color: var(--color-yellow);
  }

  &[data-domain="red"] {
    color: var(--color-red);
  }
}

.page-leave-active {
  .animated-title {
    display: block;
    transition: all 1.2s ease-in 0.1s;
  }
}

.page-leave-to {
  .animated-title {
    transform: scale(900);
  }
}
</style>
